import { Action, creator } from 'src/config/rootAction';

import {
    ChangeMindfulnessImprovementsFieldActionArguments,
    MindfulnessImprovementsTopics,
} from '../models/weekOne';

export const CHANGE_MINDFULNESS_IMPROVEMENTS_TOPIC = 'CHANGE_MINDFULNESS_IMPROVEMENTS_TOPIC';
export type ChangeMindfulnessImprovementsTopicAction = Action<
    typeof CHANGE_MINDFULNESS_IMPROVEMENTS_TOPIC,
    ChangeMindfulnessImprovementsFieldActionArguments
>;
export const changeMindfulnessImprovementsTopic = creator<ChangeMindfulnessImprovementsTopicAction>(
    CHANGE_MINDFULNESS_IMPROVEMENTS_TOPIC,
);

export const CHANGE_MINDFULNESS_IMPROVEMENTS_ADDITIONAL_INFO =
    'CHANGE_MINDFULNESS_IMPROVEMENTS_ADDITIONAL_INFO';
export type ChangeMindfulnessImprovementsAdditionalInfoAction = Action<
    typeof CHANGE_MINDFULNESS_IMPROVEMENTS_ADDITIONAL_INFO,
    ChangeMindfulnessImprovementsFieldActionArguments
>;
export const changeMindfulnessImprovementsAdditionalInfo = creator<
    ChangeMindfulnessImprovementsAdditionalInfoAction
>(CHANGE_MINDFULNESS_IMPROVEMENTS_ADDITIONAL_INFO);

export const SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_REQUESTED =
    'SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_REQUESTED';
export type SubmitMindfulnessImprovementsDataRequestAction = Action<
    typeof SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_REQUESTED,
    MindfulnessImprovementsTopics
>;
export const submitMindfulnessImprovementsData = creator<
    SubmitMindfulnessImprovementsDataRequestAction
>(SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_REQUESTED);

export const SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_SUCCEEDED =
    'SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_SUCCEEDED';
export type SubmitMindfulnessImprovementsDataSuccessAction = Action<
    typeof SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_SUCCEEDED
>;
export const submitMindfulnessImprovementsDataSuccess = creator<
    SubmitMindfulnessImprovementsDataSuccessAction
>(SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_SUCCEEDED);

export const SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_FAILED =
    'SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_FAILED';
export type SubmitMindfulnessImprovementsDataFailAction = Action<
    typeof SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_FAILED
>;
export const submitMindfulnessImprovementsDataFail = creator<
    SubmitMindfulnessImprovementsDataFailAction
>(SUBMIT_MINDFULNESS_IMPROVEMENTS_DATA_FAILED);

export const FETCH_MINDFULNESS_IMPROVEMENTS_DATA_SUCCEEDED =
    'FETCH_MINDFULNESS_IMPROVEMENTS_DATA_SUCCEEDED';
export type FetchMindfulnessImprovementsDataSuccessAction = Action<
    typeof FETCH_MINDFULNESS_IMPROVEMENTS_DATA_SUCCEEDED
>;
export const fetchMindfulnessImprovementsDataSuccess = creator<
    FetchMindfulnessImprovementsDataSuccessAction
>(FETCH_MINDFULNESS_IMPROVEMENTS_DATA_SUCCEEDED);

export const FETCH_MINDFULNESS_IMPROVEMENTS_DATA_FAILED =
    'FETCH_MINDFULNESS_IMPROVEMENTS_DATA_FAILED';
export type FetchMindfulnessImprovementsDataFailAction = Action<
    typeof FETCH_MINDFULNESS_IMPROVEMENTS_DATA_FAILED
>;
export const fetchMindfulnessImprovementsDataFail = creator<
    FetchMindfulnessImprovementsDataFailAction
>(FETCH_MINDFULNESS_IMPROVEMENTS_DATA_FAILED);

export const SET_MINDFULNESS_EXERCISE_COMPLETED = 'SET_MINDFULNESS_EXERCISE_COMPLETED';
export type SetMindfulnessExerciseCompletedAction = Action<
    typeof SET_MINDFULNESS_EXERCISE_COMPLETED
>;
export const setMindfulnessExerciseCompleted = creator<SetMindfulnessExerciseCompletedAction>(
    SET_MINDFULNESS_EXERCISE_COMPLETED,
);

export type WeekOneAction =
    | ChangeMindfulnessImprovementsTopicAction
    | ChangeMindfulnessImprovementsAdditionalInfoAction
    | SubmitMindfulnessImprovementsDataRequestAction
    | SubmitMindfulnessImprovementsDataSuccessAction
    | SubmitMindfulnessImprovementsDataFailAction
    | FetchMindfulnessImprovementsDataSuccessAction
    | FetchMindfulnessImprovementsDataFailAction
    | SetMindfulnessExerciseCompletedAction;
